import React from 'react';

const ModalContentMSP = React.createClass({
    render() {
        return (
            <div>
                <p>Our systems show that your property is in a higher risk area of theft. We will not pay for any loss or damage at the insured address caused by Theft, Attempted Theft or Malicious Damage as a result of Theft, unless the following protections are in place:</p>
                <p>
                    1.	Front or main exit door
                    <ul><li>A five lever mortice deadlock, or</li>
                    <li>For uPVC doors, an integrated multipoint locking system.</li></ul>
                </p>
                <p>
                    2.	All other external doors 
                    <br />This includes doors that are not a front or main exit door, such as French or patio doors.
                    <ul><li>Either the same type of lock as above, or</li>
                    <li>Key operated bolts fitted at the top and bottom of each door.</li></ul>
                    All doors must be securely closed and locked when the insured address is empty, or once you and any other responsible person have gone to bed.
                    <br />In this context, a responsible person means an adult that is capable of looking after the insured address. This would be the policy holder or another adult living in or looking after the property.
                </p>
                <p>
                    3.	Windows, fanlights and skylights
                    <ul><li>Key operated locks must be fitted to all windows that can be opened and are accessible</li></ul>
                </p>
                <p>Accessible means any window, fanlight or skylight that a person could reach from outside without bringing anything to the insured address to gain access, such as a ladder, stepladder, or scaffolding.</p>
                <p>All windows must be securely closed and locked when the insured address is empty, or once you and any other responsible person have gone to bed and the room is empty.</p>
    
            </div>
        );
    }
});

export default ModalContentMSP;


/** WEBPACK FOOTER **
 ** ./src/components/Modals/Content/ModalContentMSP.js
 **/